import * as React from "react";
import Content from "../../../Content";
import Axios from "../../Components/Axios";
import Chart from "react-apexcharts";
import moment from "moment";
import {Link} from "react-router-dom";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';

class Services extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            stat: [],
            now: new Date(),
            services: {}
        };
    }

    redirect() {
        this.props.history.push('/auth');
    }

    getContentProviders() {
        Axios
            .get('api/kp/list')
            .then(r => this.setState({ contentProviders: r.data }))
            .catch((e) => {
                console.log(e);
                this.redirect()
            });
    }

    async componentDidMount() {
        await Axios
            .get('api/services/list')
            .then(r => this.setState({ data: r.data }))
            .catch((e) => {
                console.log(e);
                this.redirect()
            });

        Axios
            .get('api/services/stat')
            .then(r => {
                this.setState({
                    now: new Date(r.data.now),
                    stat: r.data.stat
                });
                let services = {};

                this.state.data.map(
                    v => services[v.id] = [...new Array(7)].map((w,i) => {
                        let now = new Date(this.state.now);
                        now.setDate(now.getDate() - i);
                        return {
                            date: moment(now).format('YYYY-MM-DD'),
                            count: 0
                        }
                    }).reverse()
                );

                this.state.stat.forEach(
                    v => {
                        const service = (services[v.serviceId] ?? []).find( w => w.date === v.date );
                        (service !== undefined) && (service.count = v.count);
                    }
                );

                this.setState({
                    services: services
                });

            })
            .catch((e) => {
                console.log(e);
                this.redirect()
            });
    }

    render() {
        return (
            <Content title = "Услуги">
                <div className="container pt-2">
                    <h4 className="mb-3">Статистика по услугам</h4>
                    <div className="row">
                        {
                            this.state.data.map(v => (

                                <div className="col-6 mt-5" key={v.id}>
                                    <div className="card   shadow  border-0 rounded">
                                        <div className="row">
                                            <div className="col-6">
                                                <img style={{width: '100%'}} src={`${backendUrl}api/uploads/${v.posterRu.split('.')[0] ?? ''}`} alt=""/>
                                            </div>
                                            <div className="col-6 pt-3 pr-3 pl-0">
                                                <h5>{v.titleRu}</h5>
                                                <h1 className="mt-1">
                                                    {
                                                        (this.state.services[v.id] ?? []).find(
                                                            w => w.date === moment(this.state.now).format('YYYY-MM-DD')
                                                        )?.count
                                                    }
                                                </h1>
                                                <h6 className="mt-1">Подключений за сегодня</h6>
                                            </div>
                                            <div className="col-12 px-4">
                                                <div className="chart-container">
                                                    <div>
                                                        <Chart
                                                            type = "bar"
                                                            series = {[
                                                                {
                                                                    name: 'Подключения',
                                                                    data: (this.state.services[v.id] ?? []).map(w => w.count)
                                                                }
                                                            ]}
                                                            yaxis = {{ show: false}}
                                                            options = {
                                                                {
                                                                    chart: {
                                                                        id: "basic-bar",
                                                                        toolbar: {show: false}
                                                                    },
                                                                    xaxis: {
                                                                        categories: (this.state.services[v.id] ?? []).map(w => w.date)
                                                                    }
                                                                }
                                                            }
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 ">
                                                <Link className="btn btn-block btn-info rounded-0" to={'/admin/services/'+v.login}>
                                                    Подробнее
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
            </Content>
        );
    }
}

export default Services;